import { apiFetch, httpError } from '../services/apiFetch';

const API_URL = import.meta.env.VITE_API_URL;

export async function createCheckoutSession(tier) {
    const res = await apiFetch(`${API_URL}/api/Billing/CreateCheckoutSession`, {
        method: 'POST',
        body: JSON.stringify({ tier }),
    });
    if (!res.ok) throw await httpError(res, 'Failed to create checkout session');
    return res.json();
}

export async function createPortalSession() {
    const res = await apiFetch(`${API_URL}/api/Billing/CreatePortalSession`, {
        method: 'POST',
    });
    if (!res.ok) throw await httpError(res, 'Failed to create portal session');
    return res.json();
}

export async function fetchBillingUsage() {
    const res = await apiFetch(`${API_URL}/api/Billing/Usage`);
    if (!res.ok) throw await httpError(res, 'Failed to fetch billing usage');
    return res.json();
}

export async function fetchBillingStatus() {
    const res = await apiFetch(`${API_URL}/api/Billing/Status`);
    if (!res.ok) throw await httpError(res, 'Failed to fetch billing status');
    return res.json();
}

// Returns { eligible: bool }. Used by the subscribe page to render the right
// CTA before any Stripe Checkout starts. Server enforces the same check on
// CreateCheckoutSession regardless of what the client sends.
export async function fetchTrialEligibility() {
    const res = await apiFetch(`${API_URL}/api/Billing/TrialEligibility`);
    if (!res.ok) throw await httpError(res, 'Failed to check trial eligibility');
    return res.json();
}

// Change subscription tier. Direction-aware on the server:
//   - Upgrade → applied immediately, response.status === 'completed'
//   - Downgrade → scheduled for end of period, response.status === 'scheduled'
//                 and response.effectiveAt holds the changeover date
export async function changeTier(tier) {
    const res = await apiFetch(`${API_URL}/api/Billing/ChangeTier`, {
        method: 'POST',
        body: JSON.stringify({ tier }),
    });
    if (!res.ok) throw await httpError(res, 'Failed to change plan');
    return res.json();
}

// Cancels a previously-scheduled downgrade so the user stays on their
// current tier indefinitely.
export async function cancelPendingTierChange() {
    const res = await apiFetch(`${API_URL}/api/Billing/CancelPendingTierChange`, {
        method: 'POST',
    });
    if (!res.ok) throw await httpError(res, 'Failed to cancel pending tier change');
    return res.json();
}
